<template>
  <div>

    <div class="w-75 mx-auto">
      <div class="row my-2" v-if="data">
        <div class="col-12 text-center">
          <p class="my-0 mt-1">Img</p>
          <img
            class="img-thumbnail"
            :src="imgUrl" alt=""
            @click="openImageModal(imgUrl)"
            v-b-modal.image_modal
          />
        </div>
        <div v-if="videoUrl != '' " class="col-12 text-center">
          <p class="my-0 mt-1">Video</p>
          <video class="w-100" :src="videoUrl" controls></video>
        </div>
        <div v-if="videoUrl == '' " class="cam-container w-100 mx-auto mb-1 mb-3 text-center">
          <p class="my-0 mt-1">Video</p>
          <div class="cam-container-inner">
            <cam-slot
              :data="data.data.camera_data"
              :type="cam_type"
              :config="{ layout: 'alarm', synced: false }"
            />
          </div>
        </div>
      </div>
    </div>
    <table class="table table-sm" v-if="data">
      <tr>
        <th>{{ $t('grid.slots.info.detection_events.labels.camera_name') }}:</th>
        <td>{{ data.data.camera_data.camera.name }}</td>
      </tr>
      <tr>
        <th>{{ $t('grid.slots.info.detection_events.labels.date') }}:</th>
        <td>{{ data.data.event_created_at }}</td>
      </tr>
      <tr>
        <th>{{ $t("alarm.alarm_type") }}:</th>
        <td>{{ data.data.event_type }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import store from "@/store";
import camera from '@/store/camera_manager/camera';
import CamSlot from "../../CamSlot.vue";

export default {
  props: {
    ovnifData: Object,
  },
  components: {
    CamSlot,
  },
  data() {
    return {
      data: null,
      imgUrl: "",
      videoUrl: "",
      cam_type: "cam_pa",
    };
  },
  async mounted() {
    this.data = this.ovnifData;
    const urlImage = this.ovnifData?.data?.media?.[0]?.url || this.ovnifData?.data?.data?.images?.[0] || "default";
    const urlVideo = this.ovnifData?.data?.media?.[1]?.url || "";
    this.imgUrl = urlImage;
    this.videoUrl = urlVideo;
  },
  methods: {
    formatNum(num, decimals = 0) {
      return parseFloat(num).toFixed(decimals);
    },
    async openImageModal(imageUrl){
      await store.dispatch("image_modal/imageUrl", imageUrl );
    },
  },
};
</script>

<style></style>
